import { render, staticRenderFns } from "./CreateDataset.vue?vue&type=template&id=37a11d0c&"
import script from "./CreateDataset.vue?vue&type=script&lang=js&"
export * from "./CreateDataset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports